module.exports = __webpack_public_path__ + "img/SL-M-140-190.d5fc141a.svg";